const genericModalController = require('frontend-controller/lib/controllers/modals/generic')
const utils = require('frontend-controller/lib/utils')
const downloader = require('frontend-controller/client/downloader')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'employees',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            // colWidth: '105px',
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                // {
                //     buttonType: 'showLocation',
                // },
                // TODO: POI
                // {
                //     buttonType: 'delete',
                //     neutral: true,
                // }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_employees': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'employeeID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showExport', context: 'employeeReports', positive: false },
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_employees:create', },
                ]
            }
        },

        async showExport(context, mode){
            if(context === 'employeeReports'){

                await this.performAndStoreAction(
                    'showSelect_workingTimeExport_timeRange',
                    this.prepareAction(genericModalController.getAction({
                        component: [
                            '/',
                            'templates',
                            'core',
                            'modal',
                            'modal',
                        ],
                        config: {
                            decisionMaker: false,
                        },
                        model: {
                            titleKey: 'modal.showSelect_workingTimeExport_timeRange.title',
                            buttons: [
                                {
                                    mode: 'select',
                                    positive: true,
                                    buttonType: 'decisionComponent'
                                },
                                {
                                    buttonType: 'cancel',
                                    mode: 'abort'
                                }
                            ],
                        }
                    }, {
                        component: [
                            '/',
                            'templates',
                            'core',
                            'form',
                            'static',
                            'exportEmployeeReportSelectMonthStartTS',
                        ],
                    }))
                )
            }
        },

        async startMassExport(mode, additionalFilters){
            try {
                const actionContext = await this.performAction(
                    this.prepareAction('get_employees_forEmployeeReportExport', undefined, undefined, {
                        source: {
                            load: {
                                resourceFilters: {
                                    ...(additionalFilters || {})
                                }
                            }
                        }
                    })
                )
                const data = (((actionContext || {}).action || {}).response || {}).data || []
                let formattedDate = 'UNKNOWN_MONTH'
                if(additionalFilters.monthStartTS){
                    formattedDate = utils.moment(additionalFilters.monthStartTS).format('MMMM-YYYY')
                }

                if(utils.collectionSize(data) < 1){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.noAvailableEmployeesFound'
                        }
                    })
                }

                const downloads = []
                for(const employee of Object.values(data)){
                    const attributes = employee.attributes || {}
                    if(attributes.employeeID){
                        downloads.push(this.startExport(
                            mode,
                            {
                                ...additionalFilters,
                                employeeID: attributes.employeeID
                            },
                            `${String(attributes.employeeNickname || attributes.employeeName || 'UNKNOWN_EMPLOYEE').replaceAll(/\s+/g, '_')}_${formattedDate}.xlsx`,
                            false
                        ))
                    }
                }

                const result = await utils.promise.resolveAll(this, downloads)

                if(result.isRejected){
                    await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.multiFileDownloadError',
                            variables: {
                                nrOfEntries:    result.nrOfPromises,
                                nrOfErrors:     result.nrOfRejections,
                                nrOfSuccesses:  result.nrOfResolves,
                            }
                        }
                    })
                }
            } catch (error){
                console.error(error)
            }
        },

        async startExport(mode, additionalFilters, filename, handleError = true){
            const resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {}
            resourceFilters.filters = {
                ...resourceFilters.filters,
                ...(additionalFilters || {}),
            }

            filename = filename || 'employeeReport_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx'
            const url = `/LTR/~/exports/office/employeeReports/${mode || '~'}/${filename}?body=${Buffer.from(JSON.stringify({
                resourceFilters: resourceFilters
            })).toString('base64')}`

            try {
                await downloader.download(url, filename)
            } catch (error) {
                if(handleError){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.fileDownloadError'
                        }
                    })
                }

                // rethrow error if necessary to collect and handle them at another time. e.g., startMassExport()
                throw error
            }
        },
    },

    hooks: {
        async onDecision($element, options){
            options = options || {}
            const decisionOptions = options.decisionOptions || {}
            const {decisionComponent} = options

            if(
                decisionComponent &&
                decisionComponent.hasClass('container_templates_core_form_static_exportEmployeeReportSelectMonthStartTS') &&
                decisionOptions.mode === 'select'
            ){
                const {monthStartTS} = decisionOptions

                if(!monthStartTS){
                    return await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.missingMonthStartTS'
                        }
                    })
                }

                const monthStartDiff = utils.moment(monthStartTS).diff(utils.moment().startOf('month'), 'days')
                if(monthStartDiff >= 0){
                    return await this.performMessage({
                        messageDisplay: {
                            message: 'error:employees.export.employeeReports.futureMonthStartTS'
                        }
                    })
                }

                await this.startMassExport('~', {
                    monthStartTS,
                })

                decisionComponent.hide()
            }
        },
    },
}